import { render, staticRenderFns } from "./sch_other.vue?vue&type=template&id=0d9db653&scoped=true"
import script from "./sch_other.vue?vue&type=script&lang=js"
export * from "./sch_other.vue?vue&type=script&lang=js"
import style0 from "./sch_other.vue?vue&type=style&index=0&id=0d9db653&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9db653",
  null
  
)

export default component.exports